import Immutable from 'immutable';
import * as types from './ShoppingCart.types';

const initialState = {
    items: [],
    fetching: false,
    checking: false,
    deleting: false,
    checkingOut: false,
    checkingId: null,
    changingQuantity: false,
    changingQuantityId: null,
    shippingType: localStorage.getItem('shippingType') || 1,
}

export default function (state = initialState, action) {
    state = Immutable.fromJS(state);
    switch (action.type) {
        case types.FETCH_ITEMS:
            return state.setIn(['fetching'], true).toJS();

        case types.FETCH_ITEMS_SUCCESS:
            return state.setIn(['fetching'], false)
                .setIn(['items'], action.payload)
                .toJS();

        case types.FETCH_ITEMS_ERROR:
            return state.setIn(['fetching'], false).toJS();

        case types.CHECKOUT:
            return state.setIn(['checking'], true).toJS();

        case types.CHECKOUT_SUCCESS:
            return state.setIn(['checking'], false).toJS();

        case types.CHECKOUT_ERROR:
            return state.setIn(['checking'], false).toJS();

        case types.DELETE_ITEM:
            return state.setIn(['deleting'], true).toJS();

        case types.DELETE_ITEM_SUCCESS:
            return state.setIn(['deleting'], false).toJS();

        case types.DELETE_ITEM_ERROR:
            return state.setIn(['deleting'], false).toJS();

        case types.CHECKOUT_ITEM:
            return state.setIn(['checkingOut'], true)
                .setIn(['checkingId'], action.payload.id)
                .updateIn(['items'], (items) => {
                    const newItems = items.toJS();
                    for (let i = 0; i < newItems.length; i++) {
                        if (parseInt(newItems[i].id) === parseInt(action.payload.id)) {
                            newItems[i].checkout = action.payload.value;
                            break;
                        }

                    }
                    return newItems;
                })
                .toJS();

        case types.CHECKOUT_ITEM_SUCCESS:
            return state.setIn(['checkingOut'], false)
                .setIn(['checkingId'], null)
                .toJS();

        case types.CHECKOUT_ITEM_ERROR:
            return state.setIn(['checkingOut'], false)
                .setIn(['checkingId'], null)
                .toJS();

        case types.CHANGE_QUANTITY:
            return state.setIn(['changingQuantity'], true)
                .setIn(['changingQuantityId'], action.payload)
                .toJS();

        case types.CHANGE_QUANTITY_SUCCESS:
            return state.setIn(['changingQuantity'], false)
                .setIn(['changingQuantityId'], null)
                .updateIn(['items'], (items) => {
                    const newItems = items.toJS();
                    for (let i = 0; i < newItems.length; i++) {
                        if (parseInt(newItems[i].id) === parseInt(action.payload.id)) {
                            newItems[i] = action.payload.item;
                            break;
                        }

                    }
                    return newItems;
                })
                .toJS();

        case types.CHANGE_QUANTITY_ERROR:
            return state.setIn(['changingQuantity'], false)
                .setIn(['changingQuantityId'], null)
                .toJS();

        case types.CHANGE_ITEM_QUANTITY:
            return state.updateIn(['items'], (items) => {
                const item = items.get(action.payload.index);
                const newItem = item.setIn(['quantity'], action.payload.value);
                return items.set(action.payload.index, newItem);
            }).toJS();

        case types.SET_SHIPPING_TYPE:
            return state.setIn(['shippingType'], action.payload).toJS();

        case types.RESET_STATE:
            return initialState;

        default:
            return state.toJS();
    }
}